"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeDefaultValue = exports.themeConfigSchema = void 0;
const zod_1 = require("zod");
exports.themeConfigSchema = zod_1.z.object({
    palette: zod_1.z.object({
        primary: zod_1.z.object({
            main: zod_1.z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
        }),
        secondary: zod_1.z.object({
            main: zod_1.z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
        }),
        type: zod_1.z.enum(['light', 'dark']).default('dark'),
    }),
});
const defaultValue = {
    palette: {
        primary: { main: '#F59E18' },
        secondary: { main: '#F44336' },
        type: 'dark',
    },
};
exports.themeDefaultValue = JSON.stringify(defaultValue, null, '\t');
